// Single source of truth for logo dimensions, shared between the (server)
// component and its 'use client' styles. Kept in a neutral module — importing
// these from the styles file would turn them into client references (not real
// numbers) when read inside the server component, breaking the loop math.
// LOGO_ITEM_WIDTH is the intrinsic-aspect hint for next/image and the
// per-item width estimate used by the loop math. Items now render at their
// natural width (height-constrained), so this is an average, not a hard box.
export const LOGO_ITEM_WIDTH = 150;
export const LOGO_ITEM_HEIGHT = 56;
export const LOGO_ITEM_WIDTH_SM = 116;
export const LOGO_ITEM_HEIGHT_SM = 48;

// Equal horizontal space between every logo. Applied as a trailing margin per
// item (not flex `gap`) so the -50% loop stays seamless with variable widths.
export const LOGO_ITEM_GAP = 96;
export const LOGO_ITEM_GAP_SM = 56;